<template>
  <div>
    <v-data-table
            :headers="headers"
            :items="users"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Usuario</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                 <v-btn outlined color="blue" @click="modalUserCreate()" class="ml-4">Crear usuario</v-btn>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogUser" max-width="550px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Editar Usuario</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                           <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedUser._id" label="Id" disabled></v-text-field>
                          </v-col>
                           <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedUser.date" label="Fecha" disabled></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedUser.name" type="text" label="Nombre"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="8">
                            <v-text-field v-model="editedUser.email" type="email" label="Email"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeEditUser">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="saveEditUser">Guardar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.date="{ item }">
              {{item.date | momentDateTable}}
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editUser(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="modalDelete(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
          <!-- modal create user -->
    <v-dialog v-model="dialogUserCreate" persistent max-width="500">
        <v-card>
          <v-card-title class="card-title d-flex justify-space-between">
            <span class="headline">Nuevo Usuario</span>
          </v-card-title>
              <v-card-text>
                <v-form  v-model="validUser" ref="form" @submit.prevent="saveUser" enctype="multipart/form-data">
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="user.name" type="text" :rules="nameRules" label="Nombre" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="user.email" type="email" :rules="emailRules" label="Email" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="user.password" type="password" :rules="passRules" label="Contraseña" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="user.passwordCon" type="password" :rules="passRules" label="Confirmar contraseña" required></v-text-field>
                    </v-col>
                    <v-col v-if="this.error !== ''" cols="12" sm="12" md="12">
                      <v-alert type="error">
                      {{error}}
                    </v-alert>
                    </v-col>
                  <v-card-actions style="width:100%;">
                    <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click.stop="dialogUserCreate = false" >Cancelar</v-btn>
                      <v-btn color="blue darken-1" :disabled="!validUser" type="submit" text >Guardar</v-btn>
                  </v-card-actions>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
      </v-dialog>
       <!-- START - DIALOG DELETE -->
      <v-dialog v-model="dialogDelete" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Desea eliminar a {{this.editedUser.name}} ?</v-card-title>
          <v-card-text>No podrá recuperarlo.</v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="green darken-1" text @click="dialogDelete = false">No</v-btn>
            <v-btn color="green darken-1" text @click="deleteUser()">Si</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END - DIALOG DELETE -->
  </div>
</template>

<script>
  const moment = require('moment');
  export default {
    name:'user',
    created(){
      this.obtenerDatosUser()
    },
    data(){
      return{
        dialogUserCreate:false,
        dialogUser: false,
        validUser:true,
        dialogDelete:false,
        users:[],
        error:'',
        user:{
          name:'',
          email:'',
          password:'',
          passwordCon:''
        },
        nameRules: [
          v => !!v || 'Nombre es requerido',
          v => (v && v.length > 3) || 'Más de 3 caracteres',
        ],
        passRules: [
          v => !!v || 'Contraseña es requerida',
        v => (v && v.length >= 6) || 'Contraseña mayor o igual a 6 caracteres',
        ],
        emailRules: [
          v => !!v || 'E-mail es requerido',
          v => /.+@.+\..+/.test(v) || 'E-mail no valido',
        ],
        headers: [
          { text: 'Nombre', value: 'name',align: 'center' },
          { text: 'Email', value: 'email',align: 'center',sortable: false },
          { text: 'fecha', value: 'date' ,align: 'center'},
          { text: 'Acción', value: 'action',align: 'center', sortable: false },
        ],
        editedUser: {
          name: '',
          email:'',
          date:''
        },
        defaultUser: {
          name: '',
          email:''
        }
      }
    },
    methods:{
      async obtenerDatosUser(){
        await this.axios.get(`${this.$store.state.baseURL}/api/users`,{
            headers: { token: localStorage.getItem('token')}
            })
          .then(res => {
            const resultado = res.data 
            this.users = resultado
          })
      },
      modalUserCreate(){
        this.dialogUserCreate = true;
      },
      async saveUser(){
        if(this.user.password === this.user.passwordCon){
          const formData = new FormData()
          formData.append('name',this.user.name.toLowerCase())
          formData.append('email',this.user.email)
          formData.append('password',this.user.password)
          await this.axios.post(`${this.$store.state.baseURL}/api/users`,formData,{
            headers: { token: localStorage.getItem('token')}
            })
          .then(res => {
            this.obtenerDatosUser()
            this.user.name = ''
            this.user.email = ''
            this.user.password = ''
            this.user.passwordCon = ''
            // console.log('user creada')
            this.dialogUserCreate = false
          })
          .catch(err =>{
            console.log(err);
            this.error = "El correo ya existe"
            setTimeout(() => {
              this.error=""
            }, 3000);
          })
        }else{
          this.error = "Las contraseña no coinciden"
          setTimeout(() => {
            this.error = ''
          }, 2000);
        }
      },
      editUser (item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedUser = Object.assign({}, item)
        this.dialogUser = true
        moment.locale('es');
        const momentDate = moment(this.editedUser.date).format('MMMM Do YYYY, h:mm:ss a')
        this.editedUser.date = momentDate
      },
      modalDelete(item){
        this.editedUser = Object.assign({}, item)
        this.dialogDelete = true
      },
      async deleteUser () {
        await this.axios.delete(`${this.$store.state.baseURL}/api/users/`+this.editedUser._id,{
          headers: { token: localStorage.getItem('token')}
          })
          .then(res => {
            this.obtenerDatosUser()
            this.dialogDelete = false
          })
      },
      closeEditUser () {
        this.dialogUser = false
      },
      async saveEditUser () {
        await this.axios.put(`${this.$store.state.baseURL}/api/users/`+ this.editedUser._id,{
          name:this.editedUser.name,
          email:this.editedUser.email
        },{
           headers: { token: localStorage.getItem('token')}
        })
        .then(res => {
          this.obtenerDatosUser()
          this.closeEditUser()
        })
        .catch(err => {
          console.log(err)
        })
      },
    },
    filters:{
      momentDateTable(value) {
        moment.locale('es');
        return moment(value).format('ll')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>